import moment from 'moment';
import { ISearchBy } from '../interfaces/search';

export const utilService = {
  formatDate,
  deformatDate,
  formatDateMMMd,
};

function formatDateMMMd(searchBy: ISearchBy): string {
  const formattedDate = (date: Date | null) => moment(date).format('MMM D');
  const startDateMonth = moment(searchBy.startDate).month();
  const endDateMonth = moment(searchBy.endDate).month();

  if (startDateMonth === endDateMonth) {
    return `${moment(searchBy.startDate).format('MMM D')} - ${moment(searchBy.endDate).format('D')}`;
  }

  return `${formattedDate(searchBy.startDate)} - ${formattedDate(searchBy.endDate)}`;
}

function formatDate(date: Date): string {
  const formatedDate = date
    .toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
    .split('/')
    .join('-');
  return formatedDate;
}

function deformatDate(formattedDateString: string): Date | null {
  if (!formattedDateString) {
    return null;
  }
  const formattedDateParts = formattedDateString.split('-');
  const year = parseInt(formattedDateParts[2], 10);
  const month = parseInt(formattedDateParts[1], 10) - 1; // JS months are 0-indexed
  const day = parseInt(formattedDateParts[0], 10);
  const dateObj = new Date(year, month, day); // creates a new Date object with the given year, month, and day
  return dateObj;
}
